<template>
  <svg
    width="16"
    height="26"
    viewBox="0 0 16 26"
    fill="#A8A8A8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.04453 0L0 3.055L9.88934 13L0 22.945L3.04453 26L16 13L3.04453 0Z"
    />
  </svg>
</template>
